var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormTotalSets.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormTotalSets.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormTotalSets\">\n        <div class=\"SubmissionFormElement-form\">\n            <h3 class=\"SubmissionFormElement-header\">Total Sets Summary</h3>\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required SubmissionFormElement-inputName--wide\">TOTAL RUNNING TIME OF EPISODE(S)</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts")),0)) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts")),0), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"setsClockLimited0\" class=\"SubmissionFormElement-input SubmissionFormElement-input--time\" placeholder=\"HH\">\n                    <div class=\"SubmissionFormElement-inputSeparator SubmissionFormElement-inputSeparator--time\">:</div>\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts")),1)) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts")),1), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"setsClockLimited1\" class=\"SubmissionFormElement-input SubmissionFormElement-input--time\" placeholder=\"MM\">\n                    <div class=\"SubmissionFormElement-inputSeparator SubmissionFormElement-inputSeparator--time\">:</div>\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts")),2)) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockLimitedParts")),2), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"setsClockLimited2\" class=\"SubmissionFormElement-input SubmissionFormElement-input--time\" placeholder=\"SS\">\n                </div>\n            </div>\n\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required SubmissionFormElement-inputName--wide\">TOTAL NEW SETS</div>\n                <div class=\"SubmissionFormElement-inputWrapper SubmissionFormElement-inputWrapper--select SubmissionFormElement-inputWrapper--short\">\n                    <select name=\"setsNew\" class=\"SubmissionFormElement-select\">\n                        <option disabled selected value class=\"SubmissionFormElement-select-optionDefault\"> -- select -- </option>\n                        ";
frame = frame.push();
var t_8 = (lineno = 27, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,101]));
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("item", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                            <option value=\"";
t_5 += runtime.suppressValue(t_9, env.opts.autoescape);
t_5 += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsNew") == t_9) {
t_5 += "selected";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(t_9, env.opts.autoescape);
t_5 += "</option>\n                        ";
;
}
}
frame = frame.pop();
t_5 += "\n                    </select>\n                </div>\n            </div>\n\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required SubmissionFormElement-inputName--wide\">TOTAL OLD SETS</div>\n                <div class=\"SubmissionFormElement-inputWrapper SubmissionFormElement-inputWrapper--select SubmissionFormElement-inputWrapper--short\">\n                    <select name=\"setsOld\" class=\"SubmissionFormElement-select\">\n                        <option disabled selected value class=\"SubmissionFormElement-select-optionDefault\"> -- select -- </option>\n                        ";
frame = frame.push();
var t_12 = (lineno = 40, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "range"), "range", context, [0,101]));
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("item", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_5 += "\n                            <option value=\"";
t_5 += runtime.suppressValue(t_13, env.opts.autoescape);
t_5 += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsOld") == t_13) {
t_5 += "selected";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(t_13, env.opts.autoescape);
t_5 += "</option>\n                        ";
;
}
}
frame = frame.pop();
t_5 += "\n                    </select>\n                </div>\n            </div>\n\n\n            <div class=\"SubmissionFormElement-inputLine\">\n                <div class=\"SubmissionFormElement-inputName SubmissionFormElement-inputName--required SubmissionFormElement-inputName--wide\">TOTAL RUNNING TIME OF NEW SETS</div>\n                <div class=\"SubmissionFormElement-inputWrapper\">\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts")),0)) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts")),0), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"setsClockNew0\" class=\"SubmissionFormElement-input SubmissionFormElement-input--time\" placeholder=\"HH\">\n                    <div class=\"SubmissionFormElement-inputSeparator SubmissionFormElement-inputSeparator--time\">:</div>\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts")),1)) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts")),1), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"setsClockNew1\" class=\"SubmissionFormElement-input SubmissionFormElement-input--time\" placeholder=\"MM\">\n                    <div class=\"SubmissionFormElement-inputSeparator SubmissionFormElement-inputSeparator--time\">:</div>\n                    <input type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts")),2)) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"setsClockNewParts")),2), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += "\n                        name=\"setsClockNew2\" class=\"SubmissionFormElement-input SubmissionFormElement-input--time\" placeholder=\"SS\">\n                </div>\n            </div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormTotalSets");
context.setVariable("SubmissionFormTotalSets", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormTotalSets.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormTotalSets.jinja
// module id = 62
// module chunks = 0